module.exports = __webpack_public_path__ + "static/media/landing-hero-bg-2.c5fa25e1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/landing-hero-bg-2.jpg
 ** module id = 505
 ** module chunks = 0
 **/